'use client'

import { useResize } from '@/core/hooks/use-resize'
import { capitalizeFirstLetter } from '@/core/lib/utils/capitalize-first-letter'
import { RemoteImage } from '@/core/ui/atoms/remote-image'
import { AirportTransfer } from '@/features/cities/types/models/city.model'

type Props = {
  className?: string
  airportTransfer: AirportTransfer
}

export const AboutCity: React.FC<Props> = ({ className, airportTransfer }) => {
  const { ref, size } = useResize<HTMLDivElement>()
  return (
    <section className={className}>
      <div className='relative mx-auto flex w-fit flex-col items-end justify-center gap-8 md:flex-row'>
        <div className='relative flex w-full items-center justify-center'>
          <RemoteImage
            width={500}
            height={500}
            alt='City airport'
            src={airportTransfer.image.url}
            className='block w-auto sm:max-w-[28rem]'
          />
          <span className='bg-pale-blue-alt absolute -start-6 bottom-0 -z-10 hidden h-[calc(100%_-_3rem)] w-4/5 rounded-2xl rounded-br-none lg:block'></span>
        </div>
        <div className='relative w-full sm:max-w-[28rem]'>
          <div
            className='bg-pale-blue-alt flex flex-col gap-3 rounded-lg p-6 md:gap-6 md:rounded-2xl md:p-3'
            ref={ref}
          >
            <h2 className='text-red pt-2 text-xl font-semibold md:-top-10'>
              {capitalizeFirstLetter(airportTransfer.title)}
            </h2>
            <div
              className='justify-end text-xl font-medium'
              dangerouslySetInnerHTML={{ __html: airportTransfer.description }}
            />
          </div>
        </div>
        <span
          className='bg-pale-blue-alt absolute start-0 bottom-0 -z-50 hidden h-1/2 w-full rounded-2xl md:block lg:rounded-bl-none'
          style={{
            height: size.height,
          }}
        ></span>
      </div>
    </section>
  )
}
